import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "pwreset" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock-open" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" パスワードリセット要求")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refFrmReset",
              model: _ctx.frmReset,
              rules: _ctx.rules,
              "label-width": "150px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "ユーザID",
                  prop: "user_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "user@example.com",
                      modelValue: _ctx.frmReset.user_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frmReset.user_id) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    (_ctx.message.err)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          title: _ctx.message.msg,
                          type: "error"
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true),
                    (_ctx.message.msg && !_ctx.message.err)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 1,
                          title: _ctx.message.msg,
                          type: "success"
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("送信")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "default",
                      onClick: _ctx.back
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("戻る")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}